import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { useExcelFilesView } from '@futrli/views/hooks/useExcelFilesView';
import { UpdateFromExcelModalContent } from '@futrli/shared-services/excel-upload';
import { DriversUploadDrawer } from '@futrli/shared-services/excel-upload/excel-modals/upload/drivers-upload-drawer';

import { CreateFromExcelModalContent } from './create-from-excel-modal-content';

interface Props {
  workspaceId: string;
  organisationId: string;
  isOpen: boolean;
  handleClose: () => void;
  onSuccess: () => Promise<void>;
}

export const DriversExcelUpload = ({ workspaceId, organisationId, isOpen, handleClose, onSuccess }: Props) => {
  const { viewInstance, files, isFetchingFiles, isGeneratingTemplate, templateUrl } = useExcelFilesView(
    workspaceId,
    organisationId,
    { entityType: 'driver' }
  );

  useEffect(() => {
    if (!isFetchingFiles && !files.length && !templateUrl) {
      viewInstance.generateDriverTemplate();
    }
  }, [viewInstance, isFetchingFiles, files.length, templateUrl]);

  return (
    <DriversUploadDrawer
      title={
        files.length ? (
          <FormattedMessage id="predict.update_excel_drivers" defaultMessage="Update Excel Drivers" />
        ) : (
          <FormattedMessage id="predict.upload_drivers_from_excel" defaultMessage="Upload Drivers from Excel" />
        )
      }
      isOpen={isOpen}
      handleClose={handleClose}
      workspaceId={workspaceId}
      organisationId={organisationId}
      isLoading={isFetchingFiles || isGeneratingTemplate}
      onSuccess={onSuccess}
      isUpdateDrawer={!!files.length}
    >
      {files.length ? (
        <UpdateFromExcelModalContent
          workspaceId={workspaceId}
          organisationId={organisationId}
          config={{ entityType: 'driver' }}
          guidelinesUrl="http://support.futrli.com/en/articles/11326527-upload-non-financial-drivers-with-an-excel-spreadsheet"
        />
      ) : (
        <CreateFromExcelModalContent driverTemplateLink={templateUrl || ''} />
      )}
    </DriversUploadDrawer>
  );
};
